import { AxiosError } from 'axios'

/** Gerar arquivos (planilhas, PDFs) pode levar mais que o timeout padrão do httpClient. */
export const DOWNLOAD_TIMEOUT_MS = 60_000

/** Extrai o nome do arquivo de um header `Content-Disposition` (RFC 6266). */
export function getFileNameFromDisposition(header: string | undefined, fallback: string): string {
  if (!header) return fallback

  const encoded = /filename\*\s*=\s*[^']*''([^;]+)/i.exec(header)
  if (encoded) {
    try {
      return decodeURIComponent(encoded[1].trim().replace(/^"|"$/g, ''))
    } catch {
      // valor malformado: tenta o `filename=` simples abaixo
    }
  }

  const plain = /filename\s*=\s*("([^"]*)"|[^;]+)/i.exec(header)
  const name = (plain?.[2] ?? plain?.[1])?.trim()
  return name || fallback
}

/** Dispara o download de um Blob no navegador. */
export function saveBlob(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  document.body.appendChild(link)
  link.click()
  link.remove()
  URL.revokeObjectURL(url)
}

/**
 * Em requisições com `responseType: 'blob'` o ProblemDetails de erro também chega como Blob.
 * Converte-o de volta para objeto para que `normalizeApiError` leia `title`/`detail`. Sempre relança.
 */
export async function parseBlobError(error: unknown): Promise<never> {
  if (error instanceof AxiosError && error.response?.data instanceof Blob) {
    const blob = error.response.data
    if (blob.type.includes('json')) {
      try {
        error.response.data = JSON.parse(await blob.text())
      } catch {
        error.response.data = {}
      }
    } else {
      error.response.data = {}
    }
  }
  throw error
}
